import { ImageResponse } from '~/types/files';
import axios from './axios';

export const generateConsent = () => {
  return axios.get<Blob>('/stages/fillApplication/consent/cardholder/generate', { responseType: 'blob' }).then((res) => {
    return {
      name: res.headers['content-disposition']?.split('; ')?.[1]?.split('filename=')?.[1] || 'consent.pdf',
      blob: res.data,
    };
  });
};